import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import Paper from 'material-ui/Paper';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import ActionHistory from 'material-ui/svg-icons/action/history';
import ActionUpdate from 'material-ui/svg-icons/action/update';
import { GetJobHistory } from '../../../http/SchedulerService';

class HistoryModal extends React.Component {
  state = {
    tabIndex: 0,
    requesting: false,
    executionHistory: [],
    changesHistory: [],
    selectedChange: null,
    showChangeModal: false
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.fetchJobHistory();
    }
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const offset = -3; // Horário de Brasília (UTC-3)
    const localDate = new Date(date.getTime() + offset * 60 * 60 * 1000).toLocaleString('pt-BR')
  
    return localDate;
  };

  fetchJobHistory = () => {
    if (this.state.requesting) return;

    this.setState({ requesting: true });

    const { job } = this.props;
    GetJobHistory(job.id)
      .then(response => {
        const { execution_history, changes_history } = response.data;
        this.setState({
          executionHistory: execution_history,
          changesHistory: changes_history,
          requesting: false
        });
      })
      .catch(error => {
        console.error('Erro ao buscar histórico', error);
        this.setState({ requesting: false });
      });
  };

  handleTabChange = (value) => {
    this.setState({ tabIndex: value });
  };

  handleOpenChangeModal = (item) => {
    this.setState({
      selectedChange: item,
      showChangeModal: true
    });
  };

  handleCloseChangeModal = () => {
    this.setState({
      selectedChange: null,
      showChangeModal: false
    });
  };

  renderExecutionTab = () => {
    const { executionHistory } = this.state;

    return (
      <Paper style={{ margin: 16 }}>
        <List>
        {executionHistory.length > 0 ? (
          <Subheader>Exibindo os últimos {executionHistory.length} registros de execução</Subheader>
        ) : (
          <Subheader>Histórico de Execuções</Subheader>
        )}
          {executionHistory.length === 0 ? (
            <ListItem primaryText="Nenhuma execução encontrada." />
          ) : (
            executionHistory.map((item, index) => (
              <div key={index}>
                <ListItem
                  leftAvatar={<Avatar icon={<ActionHistory />} />}
                  primaryText={`Executado por: ${item.executed_by}`}
                  secondaryText={`Em: ${this.formatDate(item.execution_time)}`}
                />
                <Divider inset />
              </div>
            ))
          )}
        </List>
      </Paper>
    );
  };

  renderChangesTab = () => {
    const { changesHistory } = this.state;

    return (
      <Paper style={{ margin: 16 }}>
        <List>
        {changesHistory.length > 0 ? (
          <Subheader>Exibindo os últimos {changesHistory.length} registros de alteração</Subheader>
        ) : (
          <Subheader>Histórico de Alterações</Subheader>
        )}
          {changesHistory.length === 0 ? (
            <ListItem primaryText="Nenhuma alteração encontrada." />
          ) : (
            changesHistory.map((item, index) => (
              <div key={index}>
                <ListItem
                  leftAvatar={<Avatar icon={<ActionUpdate />} />}
                  primaryText={`Alterado por: ${item.changed_by || 'N/A'}`}
                  secondaryText={`Em: ${this.formatDate(item.change_timestamp)}`}
                  onClick={() => this.handleOpenChangeModal(item)}
                />
                <Divider inset />
              </div>
            ))
          )}
        </List>
      </Paper>
    );
  };

  renderChangeDetailModal = () => {
    const { selectedChange, showChangeModal } = this.state;
    
    if (!selectedChange) return null;

    return (
      <Dialog
        title="Detalhes da Alteração"
        modal={false}
        open={showChangeModal}
        onRequestClose={this.handleCloseChangeModal}
        autoScrollBodyContent={true}
      >
        <div style={{ padding: 16 }}>
          <p><strong>Identificador:</strong> {selectedChange.job_id}</p>
          <p><strong>Data de alteração:</strong> {this.formatDate(selectedChange.change_timestamp)}</p>
          <p><strong>Alterado por:</strong> {selectedChange.changed_by || 'N/A'}</p>
          <p><strong>Observação:</strong> {selectedChange.observation || 'N/A'}</p>
          <p><strong>Nome da tarefa:</strong> {selectedChange.name || 'N/A'}</p>
          <p><strong>URL:</strong> {selectedChange.url || 'N/A'}</p>
          <p><strong>Headers:</strong></p>
          <pre style={{ backgroundColor: '#f5f5f5', padding: 8, whiteSpace: 'pre-wrap' }}>
            {selectedChange.headers ? JSON.stringify(selectedChange.headers, null, 2) : 'N/A'}
          </pre>

          <p><strong>Body:</strong></p>
          <pre style={{ backgroundColor: '#f5f5f5', padding: 8, whiteSpace: 'pre-wrap' }}>
            {selectedChange.body ? (
              typeof selectedChange.body === 'object'
                ? JSON.stringify(selectedChange.body, null, 2)
                : selectedChange.body
            ) : 'N/A'}
          </pre>
          {selectedChange.trigger_data && (
            <div style={{ marginTop: 16 }}>
              <p><strong>Agendamento (Cron):</strong></p>
              <ul style={{ paddingLeft: 20, marginTop: 4 }}>
                <li><strong>Hora:</strong> {selectedChange.trigger_data.hour}</li>
                <li><strong>Minuto:</strong> {selectedChange.trigger_data.minute}</li>
                <li><strong>Segundo:</strong> {selectedChange.trigger_data.second}</li>
                <li><strong>Dia:</strong> {selectedChange.trigger_data.day}</li>
                <li><strong>Mês:</strong> {selectedChange.trigger_data.month}</li>
                <li><strong>Semana:</strong> {selectedChange.trigger_data.week}</li>
              </ul>
            </div>
          )}
        </div>
        <FlatButton
          label="Fechar"
          primary={true}
          onClick={this.handleCloseChangeModal}
        />
      </Dialog>
    );
  };

  render() {
    const actions = [
      <FlatButton
        label="Fechar"
        primary={true}
        onClick={this.props.handleClose}
      />,
    ];

    return (
      <Dialog
        title="Histórico"
        actions={actions}
        modal={false}
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        autoScrollBodyContent={true}
        titleStyle={{ backgroundColor: 'rgb(232, 232, 232)' }}
        bodyStyle={{ padding: 0 }} 
      >
        <Tabs value={this.state.tabIndex} onChange={this.handleTabChange}>
          <Tab label="Execução" value={0}>
            {this.renderExecutionTab()}
          </Tab>
          <Tab label="Alteração" value={1}>
            {this.renderChangesTab()}
          </Tab>
        </Tabs>
        {this.renderChangeDetailModal()}
      </Dialog>
    );
  }
}

export default HistoryModal;



// WEBPACK FOOTER //
// ./src/components/view/scheduler/job/HistoryModal.js